var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-callout",
    {
      attrs: {
        "class-main": "bg-secondary-5 custom-callout",
        "has-border": false,
        "has-gradient": false
      },
      scopedSlots: _vm._u([
        {
          key: "edition",
          fn: function() {
            return [
              _c("div", { staticClass: "bg-secondary-3 px-4 py-4" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-4 col-sm col-12" },
                    [
                      _c("custom-drop-down", {
                        attrs: {
                          fieldkey: "id",
                          fieldname: "name",
                          label: "Servicio:",
                          options: _vm.services,
                          placeholder: "Seleccione"
                        },
                        model: {
                          value: _vm.model.service,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "service", $$v)
                          },
                          expression: "model.service"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-md-4 col-sm col-12 px-3 px-md-5 px-sm-3 mt-3 mt-md-0 mt-sm-3"
                    },
                    [
                      _c("custom-drop-down", {
                        attrs: {
                          fieldkey: "id",
                          fieldname: "description",
                          label: "Periodo:",
                          options: _vm.periods,
                          placeholder: "Seleccione"
                        },
                        model: {
                          value: _vm.model.period,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "period", $$v)
                          },
                          expression: "model.period"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "col-md-4 col-sm col-12 mt-3 mt-md-0 mt-sm-3"
                    },
                    [
                      _c("custom-drop-down", {
                        attrs: {
                          fieldkey: "id",
                          fieldname: "name",
                          label: "Región:",
                          options: _vm.regions,
                          placeholder: "Seleccione"
                        },
                        model: {
                          value: _vm.model.region,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "region", $$v)
                          },
                          expression: "model.region"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-md-4 col-sm col-12 mt-3" },
                    [
                      _c("custom-input", {
                        attrs: {
                          icon: "fa fa-search color-orange",
                          label: "Seguro Social o SIE:",
                          "left-icon": "",
                          "mask-type": "SieOrSSN",
                          placeholder: "Escriba SSN o SIE"
                        },
                        model: {
                          value: _vm.model.ssnorsie,
                          callback: function($$v) {
                            _vm.$set(_vm.model, "ssnorsie", $$v)
                          },
                          expression: "model.ssnorsie"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-4 col-sm col-12 d-flex align-items-end justify-content-end"
                    },
                    [
                      _c(
                        "action-button",
                        {
                          attrs: {
                            i: "fa fa-search",
                            variant: "success ml-3 px-n5"
                          },
                          on: { click: _vm.onSearchHandler }
                        },
                        [_vm._v(" Buscar ")]
                      )
                    ],
                    1
                  )
                ])
              ])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c(
        "div",
        { staticClass: "p-2 color-gray-6 font-16 font-weight-normal" },
        [_vm._v(" Búsqueda de Información de Pagos ")]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }